export const SQUARE_METERS_PER_ACRE = 4046.85642
export const MAX_FIELD_SIZE = 1500 * SQUARE_METERS_PER_ACRE
export const MIN_FIELD_SIZE = 1 * SQUARE_METERS_PER_ACRE
export const MIN_FIELD_ELEMENT_SIZE = 0.1 * SQUARE_METERS_PER_ACRE
export const MAX_FIELD_TO_BBOX_RATIO = 20

export const ONE_WEEK = 7 * 24 * 60 * 60 * 1000
